import * as Yup from 'yup';

/* eslint-disable no-template-curly-in-string */
Yup.setLocale({
	mixed: {
		notType: 'Este campo é obrigatório.',
		required: 'Este campo é obrigatório',
	},
	string: {
		length: 'Deve ter exatamente ${length} caracteres',
		min: 'Deve ter pelo menos ${min} caracteres',
		max: 'Deve ter no máximo ${max} caracteres',
		matches: 'São permitidos apenas números',
		email: 'Formato de e-mail inválido',
		url: 'Formato de URL inválida',
		lowercase: 'Deve conter apenas letras minúsculas',
		uppercase: 'Deve conter apenas letras maiúsculas',
	},
	number: {
		min: 'O valor deve ser maior ou igual a ${min}',
		max: 'O valor deve ser menor ou igual a ${max}',
		lessThan: 'O valor deve ser menor do que ${less}',
		moreThan: 'O valor deve ser maior do que ${more}',
		notEqual: 'O valor deve ser diferente de ${notEqual}',
		positive: 'O valor deve ser um número positivo',
		negative: 'O valor deve ser um número negativo',
		integer: 'O valor deve ser um inteiro',
	},
});
/* eslint-enable no-template-curly-in-string */

const renderable = required =>
	Yup.lazy(value => {
		switch (typeof value) {
			case 'number':
				return required ? Yup.number().required() : Yup.number();
			case 'string':
				return required ? Yup.string().required() : Yup.string();
			default:
				return required ? Yup.mixed().required() : Yup.mixed();
		}
	});

const Validations = { Yup, renderable };

export { Validations };
